export const isAlphaNumeric = (str: string): boolean => {
  const regex = /^[0-9a-zA-Z]+$/;
  return regex.test(str);
};

export const isNumeric = (str: string): boolean => {
  const regex = /^[0-9]+$/;
  return regex.test(str);
};

export const stripUnoChars = (text: string): string => {
  if (!text) return '';
  return text.replace(/[^A-Za-z0-9]/gm, '');
};
